import { Component } from "@angular/core";
import { AbstractPopupDialogDirective } from "../_shared/abstract/abstract-popup-dialog.directive";
import { PopupDialogConfig } from "../_shared/popup.model";
import { UserService } from "@services";
import { PopupService } from "@core";

@Component({
  selector: "app-popup-page-dialog-welcome",
  templateUrl: "./popup-welcome.component.html",
  styleUrls: ["./popup-welcome.component.scss"],
})
export class PopupWelcomeComponent extends AbstractPopupDialogDirective {
  currentStep = 1;
  stepsCount = 3;

  private _configOverwrite: Partial<PopupDialogConfig> = {
    closeOnBackgroundClick: false,
  };

  onClose() {
    const userInfo = { welcomeInfo: true };
    this._userService.updateUserInfoStatus(userInfo);
  }

  constructor(
    protected override _popupService: PopupService,
    private _userService: UserService,
  ) {
    super(_popupService);
    this.config = { ...this.config, ...this._configOverwrite };
  }
}
